<dialog id="{{ modalId }}" class="modal modal-middle">
  <div class="modal-box w-full max-w-md p-9 rounded-2xl text-center">
    <img src="/branding/icon/apgap-icon-green.svg" alt="" aria-hidden="true" class="mx-auto mb-3 h-14 w-14" />
    <h2 class="text-2xl font-bold text-primary mb-3">Welcome to APGAP</h2>
    <p class="text-sm text-base-content/70 leading-relaxed mb-7">
      Let's take a 90-second tour so you know where everything lives.<br />
      You can skip anytime.
    </p>
    <div class="flex justify-center gap-3">
      <button
        type="button"
        class="btn btn-primary px-7"
        (click)="onStart()"
      >
        Start tour
      </button>
      <button
        type="button"
        class="btn btn-outline px-5"
        (click)="onSkip()"
      >
        Skip
      </button>
    </div>
  </div>
</dialog>
